import React, { useEffect } from "react";
import Amplitude from "amplitude-js";
import { Provider } from "react-redux";
import Router from "./router/router";
import { connectionString } from "../src/utils";
import "./styles/styles.css";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/ConfigureStore";
import { Toaster } from "react-hot-toast";
import "./App.css";

function App() {
  useEffect(() => {
    const ampInstance = Amplitude.getInstance();
    ampInstance.init(connectionString);
  }, []);
  return (
    <>
      <div>
        <Toaster />
      </div>

      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <Router />
        </PersistGate>
      </Provider>
    </>
  );
}

export default App;
